import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import serviceContainer from './service-container';
import App from './App.vue';
import store from './store';
import router from './router';
import { i18n } from './lang';
import './icons';
import './polyfill';

Vue.use(BootstrapVue);
Vue.use(Vuelidate);

// Initializes the Vue container
new Vue({
	provide: serviceContainer,
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app');
